import { useEffect, useRef } from 'react'

const useDidMountEffect = (func, deps, triggerOnFirstEffect = false) => {
  const didMount = useRef(false)

  useEffect(() => {
    if (triggerOnFirstEffect || didMount.current) {
      func()
    } else {
      didMount.current = true
    }
  }, deps)
}

export default useDidMountEffect
